import * as types from './types';

export default {
  state: {
    currentExercise: {},
  },
  getters: {
    [types.CURRENT_EXERCISE]: state => state.currentExercise,
  },
  mutations: {
    [types.CURRENT_EXERCISE]: (state, payload) => {
      state.currentExercise = payload.currentExercise;
    },
  },
};
